import { render, staticRenderFns } from "./wxCode.vue?vue&type=template&id=e90ced08&scoped=true&"
import script from "./wxCode.vue?vue&type=script&lang=js&"
export * from "./wxCode.vue?vue&type=script&lang=js&"
import style0 from "./wxCode.vue?vue&type=style&index=0&id=e90ced08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90ced08",
  null
  
)

component.options.__file = "wxCode.vue"
export default component.exports